/* tslint:disable:component-selector import-spacing no-trailing-whitespace no-inferrable-types typedef-whitespace */
import {
  AfterViewInit,
  Component,
  OnDestroy,
  ViewChild
}                                from '@angular/core';

import {Scenario}                from '@/models/scenario/scenario';
import {Logger}                  from '@/util/logger';
import {UnDoRedo}                from '@/util/un.do.redo';
import {TSOEditor}               from '@/screens/ide/tso/t.s.o.editor';
import {TSOSummaryTable}         from '@/screens/ide/tso/t.s.o.summary.table';
import {TSOChange}               from '@/screens/ide/tso/t.s.o.change';
import {TSOInlineEdit}           from '@/screens/ide/tso/t.s.o.inline.edit';
import {BlobService}             from '@/services/blob.service';
import {AlertService}            from '@/services/alert.service';
import {ICommand}                from '@/util/i.command';
import {AddTSOCommand}           from '@/screens/ide/tso/add.t.s.o.command';
import {DeleteTSOCommand}        from '@/screens/ide/tso/delete.t.s.o.command';
import {BlobType}                from '@/models/blob';

import {SlowOrdersSchema}        from '@/models/scenario/slow.orders.schema';
import {TSOLinksSchema}          from '@/models/scenario/t.s.o.links.schema';
import {TSOSpeedsSchema}         from '@/models/scenario/t.s.o.speeds.schema';

import {Tabs}                    from '@/components/tabs';

import KeyDownEvent = JQuery.KeyDownEvent;

import * as $                    from 'jquery';
import 'gasparesganga-jquery-loading-overlay';

import {
  BehaviorSubject,
  Subscription
}                                from 'rxjs';
import {first}                   from 'rxjs/operators';
import {basename, empty}         from "@/util/util";
import {StatusReporter} from "@/util/status.reporter";

@Component({
  selector: 'tso-editor-component',
  template: `

    <!-- the work blox loader drop down -->
    <div class="tso-loader-wrapper" (click)="$event.stopPropagation();">

      <div
        class="tso-expander"
        (click)="toggleLoader()"
        [class.disabled]="scenarioKey !== ''"
        [innerHTML]="expanderElement"
        title="Select Scenario">
      </div>

      <div
        class="tso-save-scenario"
        [class.disabled]="(scenario === null) || (scenarioKey === '') || !canAdd()"
        [class.editorbusy]="editorBusy"
        (click)="saveScenario()"
        [innerHTML]="saveScenarioElement"
        title="Save Scenario">
      </div>
      <div
        class="tso-download-scenario"
        [class.disabled]="(scenario === null) || (scenarioKey === '') || !canAdd()"
        [class.editorbusy]="editorBusy"
        (click)="downloadScenario()"
        [innerHTML]="downloadScenarioElement"
        title="Download Scenario">
      </div>
      <div
        class="tso-clear-input"
        [class.disabled]="!hasInput()"
        [class.editorbusy]="editorBusy"
        (click)="clearCurrentInput()"
        [innerHTML]="clearTSOElement"
        title="Clear input data">
      </div>
      <div
        [ngClass]="{'tso-add-tso': true, 'disabled': !canAdd()}"
        [class.editorbusy]="editorBusy"
        (click)="addNewTSO()"
        [innerHTML]="addTSOElement"
        title="Add new TSO"></div>
      <div
        class="tso-delete-tso"
        [class.disabled]="!isDeletable()"
        [class.editorbusy]="editorBusy"
        (click)="deleteTSO()"
        [innerHTML]="deleteTSOElement"
        title="Delete TSO"></div>
      <div
        class="tso-undo"
        [class.disabled]="undoManager.undoSize() === 0"
        [class.editorbusy]="editorBusy"
        (click)="undo()"
        [innerHTML]="undoElement"
        title="Undo last change"></div>
      <div
        class="tso-redo"
        [class.disabled]="undoManager.redoSize() === 0"
        [class.editorbusy]="editorBusy"
        (click)="redo()"
        [innerHTML]="redoElement" title="Redo last change"></div>

      <div class="tso-loader-panel" [class.expanded]="loaderActive">
        <div id="tso-loader-form-drop-area_{{u}}" class="tso-loader-form-drop-area drop-area">

            <p>To select a new scenario, drop a scenario on this dashed area, or click Browse.</p>
            <input
              (change)="onFileBrowse($event.target.files); $event.stopPropagation(); false"
              type="file"
              id="tso-loader-upload_{{u}}"
              class="tso-loader-upload"
              style="display: none !important;">

          <label
              class="gui-button primary"
              for="tso-loader-upload_{{u}}"
              (click)="browseClick($event); $event.stopPropagation(); false">
              Browse
            </label>

        </div>

        <div class="tso-scenario-name">
          <span class="tso-scenario-label">Scenario:</span>
          <span class="tso-scenario-title" [innerHTML]="scenarioTitle"></span>
        </div>


        <div *ngIf="errorLine!==''" id="tso-scenario-error_{{u}}" class="tso-scenario-error" [innerHTML]="errorLine">
        </div>

      </div>
    </div>

    <!-- outer shell for the work blox editor -->
    <div class="tso-editor-shell" style="text-align:center">
      <tso-editor
        (edit)="onEdit($event)"

        uuid={{u}}
        id="tso_ed_{{u}}">

      </tso-editor>
    </div>

    <!-- outer shell for the tso summaries -->
    <div class="tso-editor-summary-shell" style="text-align:center">
      <tabs>
        <tab title="Summary">
          <tso-summary-table  uuid={{u}} id="tso_st_{{u}}"></tso-summary-table>
        </tab>

      </tabs>
    </div>
  `
})

export class TSOEditorComponent implements AfterViewInit, OnDestroy, StatusReporter {

  /* for uniq'ifying our drop #id's */

  public static  instanceNum:     number = 0;
  public u: number = TSOEditorComponent.instanceNum;

  /** hint for window title, whatever we have for the basename of the scenario file */
  public           fileName: string      = '';

  /** the history manager for the tso editor */
  public undoManager:           UnDoRedo = new UnDoRedo(`TSOHistory`);

  /** the currently active row/selection/tso */
  private selectedWorkBlock: BehaviorSubject<TSOChange>;
  private selectSub:        Subscription = null;

  /** the most recent inline edit (single field) */
  private lastInlineEdit: BehaviorSubject<TSOInlineEdit>;
  private editSub:          Subscription = null;

  /** track when the file drop area panel is shown */
  public  loaderActive:         boolean  = false;

  /** the content to show for the expand collapse button */
  public expanderElement:         string = '<i class="fas fa-angle-down"></i>';

  public clearTSOElement:         string = '<i class="fas fa-ban"></i>';
  public addTSOElement:           string = '<i class="fas fa-plus"></i>';
  public deleteTSOElement:        string = '<i class="far fa-trash-alt"></i>';
  public undoElement:             string = '<i class="fas fa-undo"></i>';
  public redoElement:             string = '<i class="fas fa-redo"></i>';
  public saveScenarioElement:     string = '<i class="far fa-save"></i>';
  public downloadScenarioElement: string = '<i class="fas fa-file-download"></i>';

  /** set to true when actions should be blocked because the editor is busy */
  public editorBusy:              boolean = false;

  /* the visible name of the scenario being browsed */
  public   scenarioTitle:         string = '';

  /* the error feedback if required */
  public       errorLine:         string = '';

  /* the current scenario model */
  public       scenario:        Scenario = null;

  /* the object version of the JSON used to load the scenario */
  public           json: any;

  /* blob key of scenario if it was loaded from a blob */
  public    scenarioKey:          string = '';

  @ViewChild(TSOEditor, {static: false})
  public         editor: TSOEditor;

  @ViewChild(TSOSummaryTable, {static: false})
  public table: TSOSummaryTable;

  @ViewChild(Tabs, {static: false})
  private tabs: Tabs;

  /* general call back for when we reload */
  public reloaded: () => void;

  /** standard constructor */
  constructor(
    private blobber: BlobService,
    private alerts:  AlertService
  ) {

    Logger.debug('[tso] dynamically creating...');

    /* setup an observable selection that every one can subscribe to */

    this.selectedWorkBlock = new BehaviorSubject<TSOChange>(null);

    this.selectSub = this.selectedWorkBlock.subscribe( (next: TSOChange) => {

      this.selected(next);
    });

    /* setup an observable for the inline edits */

    this.lastInlineEdit = new BehaviorSubject<TSOInlineEdit>(null);

    this.editSub = this.lastInlineEdit.subscribe( (next: TSOInlineEdit) => {

      this.inlineEdited(next);
    });

  }

  /** handle single column changes in the editing inputs */
  public inlineEdited(edit: TSOInlineEdit) {

    Logger.debug('[tso] inline edit', edit);

    /* TODO: */

  }

  /** handle changes to which work block is selected */
  public selected(change: TSOChange) {

    Logger.debug('[tso] selection change', change);

    /* TODO: */



  }

  /** check if we have any input in the editing fields */
  public hasInput(): boolean {

    if (typeof this.editor === 'undefined') {

      return false;
    }

    if (this.editor === null) {

      return false;
    }

    return this.editor.hasInput();
  }

  /** check if the current editing input is a wor/WorkBlock that we can delete */
  public isDeletable(): boolean {

    if (typeof this.editor === 'undefined') {

      return false;
    }

    if (this.editor === null) {

      return false;
    }

    return this.editor.isDeletable();
  }

  /** check to see if the current editing input is good enough to add as a new WorkBlock */
  public canAdd(): boolean {

    if (typeof this.editor === 'undefined') {

      return false;
    }

    if ((this.scenario === null) || (this.editor === null)) {

      return false;
    }

    return this.editor.isValid();
  }

  ngOnDestroy(): void {

    if (this.selectSub !== null) {

      /* unsubscribe our observer */

      this.selectSub.unsubscribe();
    }
  }

  ngAfterViewInit(): void {

    $('tso-editor-component').keydown((e: KeyDownEvent) => {

      if (e.key.toLowerCase() === 'escape') {

        e.preventDefault();
        e.stopPropagation();

        return false;
      }

      if (e.ctrlKey && (e.key.toLowerCase() == 'v')) {

        /* add */

        this.addNewTSO();

        e.preventDefault();
        e.stopPropagation();

        return false;

      } else if (e.ctrlKey && (e.key.toLowerCase() == 'x')) {

        /* delete */

        this.deleteTSO();

        e.preventDefault();
        e.stopPropagation();

        return false;

      } else if (e.ctrlKey && (e.key.toLowerCase() == 'z')) {

        /* undo */

        this.undo();

        e.preventDefault();
        e.stopPropagation();

        return false;

      } else if (e.ctrlKey && (e.key.toLowerCase() == 'y')) {

        /* redo */

        this.redo();

        e.preventDefault();
        e.stopPropagation();

        return false;
      }

    });

    /* get the scenario drop box */

    const instanceId: string = `tsoec_${this.u}`;

    Logger.debug(`[tso] setting up drop zone..., instance id=${instanceId}...`);

    /* - - - - - -  add in drag n' drop behaviors */

    /* get the drop box */

    const dropArea: HTMLElement = $(`#tso-loader-form-drop-area_${this.u}`).get(0);

    /* prevent bubble up, we're handling drag n' drop for this area */

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {

      dropArea.addEventListener(eventName, (e) => {

        e.preventDefault();
        e.stopPropagation();

      }, false);

    });

    ['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, (e) => {

        $(`#tso-loader-form-drop-area_${this.u}`).addClass('highlight');

      }, false);

    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, (e) => {

        $(`#tso-loader-form-drop-area_${this.u}`).removeClass('highlight');

      }, false);

    });

    dropArea.addEventListener('drop', (e) => {

      const dt = e.dataTransfer;

      this.onFileBrowse(Array.from(dt.files));

    }, false);

    /* tell the sub-components what history manager to use */

    this.editor.setHistory(this.undoManager);
    this.table.setHistory(this.undoManager);

    /* make sure next instance of editor is unique */

    TSOEditorComponent.instanceNum++;
  }

  /** simple trigger for getting the hidden file button to pop its dialog */
  public browseClick(e: MouseEvent) {

    document.getElementById(`tso-loader-upload_${this.u}`).click();

    e.stopPropagation();

  }

  /** update the error line in the loader drop down */
  public status(msg: string =  '') {

    if (this.editor) {

      this.editor.status(msg);
    }

    Logger.info(`[tso] ${msg}`);
  }

  /** update the error line in the loader drop down */
  public success(msg: string =  '') {

    if (this.editor) {

      this.editor.success(msg);
    }

    Logger.debug(`[tso] ${msg}`);
  }

  /** update the error line in the loader drop down */
  public error(msg: string =  '') {

    if (this.editor) {

      this.editor.error(msg);
    }

    Logger.error(`[tso] ${msg}`);
  }

  /** helper to convert the current scenario (and work blocks) into JSON string */
  public toText(): string {

    /*
     * hack alert; instead of writing the full serialization for the entire scenario and all the
     * various kinds of blocks inside it...we're just doing it incrementally, for now, use the
     * the exact JSON object we loaded...and just overwrite the 'slow_orders' section.
     * Then, stringify that whole JSON, and save / download that string.
     *
     * This minimizes what we can mess up, because we're only twitching slow orders part. There
     * may still be some conversion issues; because for example floating point numbers were read
     * in by the JSON parser built into the browser...which may...or may not...make the same
     * assumptions/implementation choices about parsing and outputing floating point numbers...we
     * have no control over that :(
     *
     */

    const        sos: SlowOrdersSchema = new SlowOrdersSchema();
    const sosSection:              any = sos.render(Array.from(this.scenario.tso().values()));

    if ( sosSection === null) {

      Logger.error(`[tso] can't convert to text: ${sos.lastError}`);
      return null;
    }

    const        tls: TSOLinksSchema = new TSOLinksSchema();
    const tlsSection:            any = tls.render(Array.from(this.scenario.tso().values()));

    if ( tlsSection === null) {

      Logger.error(`[tso] can't convert to text: ${tls.lastError}`);
      return null;
    }

    const        tss: TSOSpeedsSchema = new TSOSpeedsSchema();
    const tssSection:             any = tss.render(Array.from(this.scenario.tso().values()));

    if ( tssSection === null) {

      Logger.error(`[tso] can't convert to text: ${tss.lastError}`);
      return null;
    }

    this.json.scenario['slow_orders'] = {
      slow_orders: sosSection.slow_orders,
      tso_links:   tlsSection.tso_links,
      tso_speeds:  tssSection.tso_speeds
    };

    Logger.debug(`[tso] new scenario:`, this.json);

    return JSON.stringify(this.json);
  }

  public saveScenario() {

    if ((this.scenario === null) || (this.scenarioKey === '')  || !this.canAdd()) {

      Logger.debug('[tso] can not save right now.');

      return ;
    }

    if (this.editorBusy === true) {

      /* already saving */

      return ;
    }

    this.status("Saving scenario...");
    this.editorBusy = true;

    const text: string = this.toText();

    Logger.debug(`[tso] saving (key='${this.scenarioKey}', sz=${text.length})...`);

    this.blobber.update(this.scenarioKey, text)
      .pipe(first())
      .subscribe(
        () => {

          this.success("Saving complete!");
          this.editorBusy = false;

          Logger.debug('[tso] scenario saved.');

        },
        error => {

          this.editorBusy = false;
          this.error("Could not save: " + error);

          Logger.error('[tso] can not save scenario: ', error);

          this.alerts.error(error.error.message, {autoClose: true});

        });
  }

  public downloadScenario() {

    if (this.editorBusy === true) {

      /* already saving */

      this.editorBusy = false;

      return ;
    }

    this.status("Starting download...");

    this.editorBusy = true;

    const text: string = this.toText();

    if (text === null) {

      Logger.debug(`[tso] could not convert to text.`);

      this.editorBusy = false;

      return ;
    }

    Logger.debug(`[tso] downloading (sz=${text.length})...`);

    const type: BlobType = BlobType.Scenario;
    const mime: string   = 'application/json';

    let keyBase = this.scenarioKey.substring(this.scenarioKey.lastIndexOf('/') + 1);

    if (!keyBase || keyBase === '' ) {

      keyBase = this.scenarioKey;
    }

    /* make a downloadable blob... */

    const blob = new Blob([text], { type: mime });
    const url  = window.URL.createObjectURL(blob);

    /* setup a fake one-time link with the right download name and the blob attached as the download */

    const element: HTMLAnchorElement = document.createElement('a');
    element.href                     = url;
    element.download                 = keyBase || 'download';
    element.style.display            = 'none';

    document.body.appendChild(element);

    /* do it */

    element.click();

    /* clean up */

    document.body.removeChild(element);

    this.editorBusy = false;
  }

  public clearCurrentInput() {

    Logger.debug(`[tso] clearing current input.`);

    this.editor.clear();
    this.table.clearSelection();

  }

  public addNewTSO() {

    if (!this.canAdd()) {

      Logger.error(`[tso] can not add right now`);

      return ;
    }

    this.status('Adding TSO...');

    Logger.debug(`[tso] adding new tso...`);

    /* convert current input/selection to a change object we can use with a history command */

    const add: TSOChange       = this.table.getSelection();

    add.src = this;

    const cmd: ICommand        = new AddTSOCommand(add, this);

    /* use the command to do the add */

    cmd.execute();

    /* track in history */

    this.undoManager.insert(cmd);

    this.success('Added.');
  }

  public deleteTSO() {

    if (!this.isDeletable()) {

      Logger.error(`[tso] can not delete right now.`);
      return ;
    }

    this.status('Deleting block...');

    Logger.debug(`[tso] deleting tso...`);

    /* convert current input/selection to a change object we can use with a history command */

    const del: TSOChange = this.table.getSelection();

    del.src = this;

    const cmd: ICommand        = new DeleteTSOCommand(del, this);

    /* use the command to do the add */

    cmd.execute();

    /* track in history */

    this.undoManager.insert(cmd);

    this.success('Deleted.');
  }

  public undo() {

    if (this.undoManager.undoSize() === 0) {

      Logger.error(`[tso] can not undo right now.`);

      return ;
    }

    Logger.debug(`[tso] undo ... `);

    this.undoManager.undo();
  }

  public redo() {

    if (this.undoManager.redoSize() === 0) {

      Logger.error(`[tso] can not redo right now.`);

      return ;
    }

    Logger.debug(`[tso] redo ... `);

    this.undoManager.redo();
  }

  /** react to the user browsing a local windows scenario file */
  public onFileBrowse(files: File[]) {

    if (!files || (files.length === 0)) {

      /* nothing to do */

      return ;
    }

    const upload: File = files[0];

    this.fileName = upload.name;

    Logger.debug('[tso] setting scenario via file: ', upload);

    this.status('');

    /* read in the raw text */

    const reader = new FileReader();

    reader.onerror = (msg) => {

      this.error('Problems uploading: ' + msg);
    };

    reader.onload = (event: ProgressEvent<FileReader>) => {

      const text = event.target.result;

      this.fromText(String(text), this.fileName);

    };

    reader.readAsText(upload);
  }

  public fromText(text: string, key: string = '') {

    Logger.debug(`[tso] loading from raw text (${key})...`);

    const tso: TSOEditorComponent = this;

    /* convert to JSON */

    tso.scenarioKey = key;
    tso.json        = null;

    tso.fileName = '';

    if (!empty(key)) {

      tso.fileName = basename(key);
    }


    try {

      tso.json = JSON.parse(text);

    } catch (e) {

      Logger.error('[tso] Can not parse scenario JSON: ' + e);
      tso.error('Can not parse scenario JSON: ' + e);

      return ;
    }

    /* try to construct a new model */

    tso.onScenarioLock('Building from JSON...');

    const newScenario: Scenario = new Scenario(tso.json, null, tso);

    tso.onScenarioUnlock();

    if (!newScenario.isReady()) {

      Logger.error('[tso] Could not read scenario: ' + newScenario.getError());
      tso.error(`Can not build scenario from JSON.`);

      return ;
    }

    Logger.debug('[tso] scenario created.');

    /* success */

    setTimeout( () => {

      tso.setScenario(newScenario);

      if (tso.loaderActive) {

        tso.toggleLoader();

      }

      /* let any user of this component know that we have reloaded the view */

      tso.reloaded();

    }, 600);

  }

  /** when the main editor does any edits, we have to refresh the summary views. */
  public onEdit(s: Scenario) {

  }

  /** @brief lock user interaction */
  public onScenarioLock(msg: string = '') {

    Logger.debug('[tso] locking ' + msg);

    // @ts-ignore
    $.LoadingOverlay('show', {
      text: msg,
      background: 'rgba(255, 255, 255, 0.85)',
      textColor: 'black',
      imageColor: 'black'

    });

    // @ts-ignore
    $.LoadingOverlay('text', msg);

  }

  /** @brief unlock user interaction */
  public onScenarioUnlock(msg: string = '') {

    Logger.debug('[tso] unlocking ' + msg);

    // @ts-ignore
    $.LoadingOverlay('hide');

    // @ts-ignore
    $.LoadingOverlay('text', msg);
  }

  /** set the scenario using the given JSON */
  public setScenario(s: Scenario) {

    Logger.debug('[tso] setting new scenario...');

    this.scenarioTitle = `[<i>${s._author}</i>] ${s._tag}`;
    this.scenario      = s;
    this.status('');

    /* set the "model" */

    this.editor.setScenario(this.scenario);
    this.editor.setSelectionSubject(this.selectedWorkBlock);
    this.editor.setInlineEditSubject(this.lastInlineEdit);

    /* tell the summary table there is a new set of work blocks */

    this.table.setScenario(this.scenario);
    this.table.setSelectionSubject(this.selectedWorkBlock);
    this.table.setInlineEditSubject(this.lastInlineEdit);

    /* let the summary table capture user input */

    this.table.inputCapture = (): TSOChange => {

      return this.editor.captureInput();
    };

    /* let the summary table restore user input */

    this.table.inputRestore = (snapshot: TSOChange): void => {

      this.editor.restoreInput(snapshot);
    };

  }

  /** open the scenario loader drop down panel (or close it) */
  public toggleLoader() {

    if (this.loaderActive) {

      /* collapse */

      this.loaderActive    = false;
      this.expanderElement = '<i class="fas fa-angle-down"></i>';

      return ;
    }

    /* expand */

    this.loaderActive    = true;
    this.expanderElement = '<i class="fas fa-angle-up"></i>';
  }

}
